import {
  TableBodyCellProps,
  TableColumn,
  TableHeadCellProps,
  TableProps,
  UsePaginationReturn,
} from '@vtex/admin-ui';
import { Dropdown, Pagination, Table } from '../../../../components';
import { Product } from '../../../../shared';
import styles from './style.module.css';

type Props = {
  columns: TableColumn<Product>[];
  initialSelectedOption: number;
  itemsPerPage: number;
  numberOfItems: number;
  options: number[];
  products: Product[];
  onChange: (selectedOption: number | null) => void;
  onPageChange: (pagination: UsePaginationReturn) => void;
  getBodyCell: (
    column: TableColumn<Product>,
    item: Product,
  ) => TableBodyCellProps<Product>;
  getHeadCell:
    | ((column: TableColumn<Product>) => TableHeadCellProps<Product>)
    | undefined;
  getTable: () => TableProps<Product>;
};

export const ProductsTable = ({
  columns,
  initialSelectedOption,
  itemsPerPage,
  numberOfItems,
  options,
  products,
  getBodyCell,
  getHeadCell,
  getTable,
  onChange,
  onPageChange,
}: Props) => {
  return (
    <>
      <Table
        columns={columns}
        data={products}
        getBodyCell={getBodyCell}
        getHeadCell={getHeadCell}
        getTable={getTable}
      />
      <div className={styles.paginationContainer}>
        <Dropdown
          options={options}
          initialSelectedOption={initialSelectedOption}
          onChange={onChange}
        />
        {numberOfItems && (
          <Pagination
            totalItems={numberOfItems}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};
